export const firstToUpper = (str) => str.charAt(0).toUpperCase() + str.slice(1);
